import { PostAddIndustryTypeProps } from "../types/types";
import Apimanager from "./axios";

export const getIndustryTypesApi = async () => {
  const res = await Apimanager.get(`/admin/generic/industries`);
  return res.data;
};

export const postAddIndustryTypeApi = async (
  data: PostAddIndustryTypeProps
) => {
  const res = await Apimanager.post(`/admin/generic/industries`, data);
  return res.data;
};

export const putUpdateIndustryTypeApi = async ({
  id,
  data,
}: {
  id: number;
  data: PostAddIndustryTypeProps;
}) => {
  const res = await Apimanager.put(`/admin/generic/industries/${id}`, data);
  return res.data;
};

export const postGenerateQrCodeApi = async (data: { url: string }) => {
  const res = await Apimanager.post(`/admin/generic/generate_qr`, data, {
    responseType: "blob",
  });
  return res.data;
};
